/**
 * 登录信息/登出 会话管理
 * */
import { RawMenuType } from '@/typings/data.d';

export default {
  getUser() {
    let currentUser: string | object;
    try {
      currentUser = JSON.parse(window.sessionStorage.getItem('currentUser') || '') || {};
    } catch (e) {
      currentUser = {};
    }
    return currentUser;
  },

  // TODO 内部可直接使用window.AppGlobal，兼容fish菜单；此user对象里面有_csrf,不需要单独提供csrf相关的方法
  saveUser(user: object) {
    window.sessionStorage.setItem('currentUser', JSON.stringify(user));
  },

  getData(key: string) {
    let result;
    try {
      result = JSON.parse(window.sessionStorage.getItem(key) || '') !== null ? JSON.parse(window.sessionStorage.getItem(key) || '') : {};
    } catch (e) {
      result = {};
    }
    return result;
  },

  saveData(key: string, data: string | boolean | RawMenuType | undefined) {
    window.sessionStorage.setItem(key, typeof data === 'string' ? data : JSON.stringify(data));
  },

  removeData(key: string) {
    window.sessionStorage.removeItem(key);
  },
};
